export enum ResourcePoolMeta {
  MODEL = "resourcepool",
  PK = "id",
}
